export { default as UserSolidIcon } from './UserSolidIcon';
